import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppLayout } from "@/components/layout/AppLayout";
import { RequireAuth } from "@/components/layout/RequireAuth";
import { AuthProvider } from "@/hooks/useAuth";

import AccountPassword from "@/pages/AccountPassword";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Servers from "@/pages/Servers";
import ServerDetail from "@/pages/ServerDetail";
import Containers from "@/pages/Containers";
import Networks from "@/pages/Networks";
import Volumes from "@/pages/Volumes";
import Backups from "@/pages/Backups";
import Monitoring from "@/pages/Monitoring";
import Logs from "@/pages/Logs";
import Jobs from "@/pages/Jobs";
import SitesDomains from "@/pages/SitesDomains";
import WordPress from "@/pages/WordPress";
import Deployments from "@/pages/Deployments";
import GitRepositories from "@/pages/GitRepositories";
import Databases from "@/pages/Databases";
import Email from "@/pages/Email";
import EmailDomainDetail from "@/pages/EmailDomainDetail";
import NginxProxyManager from "@/pages/NginxProxyManager";
import Cloudflare from "@/pages/Cloudflare";
import CloudflareZone from "@/pages/CloudflareZone";
import Clients from "@/pages/Clients";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import ClientDetail from "@/pages/ClientDetail";
import Inventory from "@/pages/Inventory";
import Users from "@/pages/Users";
import VaultSecrets from "@/pages/VaultSecrets";
import Settings from "@/pages/Settings";
import ClientPortal from "@/pages/ClientPortal";
import DomainDetail from "@/pages/DomainDetail";
import AdminTickets from "@/pages/AdminTickets";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            {["/accept-invite", "/forgot-password", "/reset-password"].map(path => <Route key={path} path={path} element={<AccountPassword />} />)}
            <Route element={<RequireAuth />}>
              <Route path="/portal" element={<ClientPortal />} />
              <Route element={<AppLayout />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/servidores" element={<Servers />} />
                <Route path="/servidores/:id" element={<ServerDetail />} />
                <Route path="/containers" element={<Containers />} />
                <Route path="/redes" element={<Networks />} />
                <Route path="/volumes" element={<Volumes />} />
                <Route path="/backups" element={<Backups />} />
                <Route path="/monitoramento" element={<Monitoring />} />
                <Route path="/logs" element={<Logs />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/dominios" element={<SitesDomains />} />
                <Route path="/dominios/:domain" element={<DomainDetail />} />
                <Route path="/wordpress" element={<WordPress />} />
                <Route path="/deployments" element={<Deployments />} />
                <Route path="/git" element={<GitRepositories />} />
                <Route path="/bancos" element={<Databases />} />
                <Route path="/email" element={<Email />} />
                <Route path="/email/:id" element={<EmailDomainDetail />} />
                <Route path="/npm" element={<NginxProxyManager />} />
                <Route path="/cloudflare" element={<Cloudflare />} />
                <Route path="/cloudflare/:zoneId" element={<CloudflareZone />} />
                <Route path="/clientes" element={<Clients />} />
                <Route path="/clientes/:id" element={<ClientDetail />} />
                <Route path="/inventario" element={<Inventory />} />
                <Route path="/chamados" element={<AdminTickets />} />
                <Route path="/projetos" element={<Projects />} />
                <Route path="/projetos/:id" element={<ProjectDetail />} />
                <Route path="/usuarios" element={<Users />} />
                <Route path="/vault" element={<VaultSecrets />} />
                <Route path="/configuracoes" element={<Settings />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
